import axios from '@/axios'

export default {
  // NOTE: calling this method project create is a bit pointless since there is no other valid context. However
  // the name is consistent with the convention when we pass in projectId
  projectCreate: (cbOk, cbErr, projectId, instance) => {
    // NOTE: We send the redirect_url so that the email that goes out, has a link back to the correct vue path
    // The API will tack on a token, call back to Vue and that will present a form to confirm the new account
    // NOTE: location.origin includes the protocol and port like http://example.com:1234
    instance.project_id = projectId
    axios.post('/user/invitations.json', {email: instance.email, role: instance.role, project_id: projectId, redirect_url: location.origin + '/confirm-invitation'})
      .then(response => {
        if (cbOk) cbOk(response.data.data)
      })
      .catch(err => {
        if (cbErr) cbErr(err)
      })
  }
}



// WEBPACK FOOTER //
// ./src/services/invitation.js